import { computed, onMounted, reactive, toRefs } from 'vue'
import { log } from '@/services/log'

export const useBattery = () => {
  const state = reactive({
    battery: {
      charging: false,
      chargingTime: 0,
      dischargingTime: 0,
      level: 100,
    },
  })

  const updateBattery = (target) => {
    for (const key in state.battery) {
      state.battery[key] = target[key]
    }
    state.battery.level = state.battery.level * 100
  }

  const calcDischargingTime = computed(() => {
    const hour = state.battery.dischargingTime / 3600
    const minute = (state.battery.dischargingTime / 60) % 60
    return `${~~hour} Hour(s) ${~~minute} Minute(s)`
  })

  const calcChargingTime = computed(() => {
    log(state.battery)
    const hour = state.battery.chargingTime / 3600
    const minute = (state.battery.chargingTime / 60) % 60
    return `${~~hour} Hour(s) ${~~minute} Minute(s)`
  })

  const batteryStatus = computed(() => {
    if (state.battery.charging && state.battery.level >= 100) {
      return 'FULL'
    } else if (state.battery.charging) {
      return 'CHARGING'
    } else {
      return 'DISCONNECTED'
    }
  })

  onMounted(async () => {
    const BatteryManager = await window.navigator.getBattery()
    updateBattery(BatteryManager)

    BatteryManager.onchargingchange = ({ target }) => {
      updateBattery(target)
    }
    BatteryManager.onchargingtimechange = ({ target }) => {
      updateBattery(target)
    }
    BatteryManager.ondischargingtimechange = ({ target }) => {
      updateBattery(target)
    }
    BatteryManager.onlevelchange = ({ target }) => {
      updateBattery(target)
    }
  })

  return {
    ...toRefs(state),
    batteryStatus,
    calcDischargingTime,
    calcChargingTime,
  }
}
